import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	currentUserHasAccess,
	PermissionName,
} from '@netx/core-permissions-next/enablers';
import {type ISavedCart} from '../schema';

export const canCreateShareLinkFromSavedCart = (savedCart?: ISavedCart) => {
	if (!savedCart || !savedCart.contentCount) return false;
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return currentUserHasAccess(PermissionName.CREATE_SHARE_LINKS);
};

export default canCreateShareLinkFromSavedCart;
